import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Register = () => {
  const [activeTab, setActiveTab] = useState('company');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    companyName: '',
    companyAddress: '',
    companyCity: '',
    companyState: '',
    companyCountry: '',
    companyPhone: '',
    companyEmail: '',
    companyGST: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const validateCompanyTab = () => {
    if (!formData.companyName.trim()) {
      setError('Company Name is required');
      return false;
    }
    return true;
  };

  const validateUserTab = () => {
    if (!formData.username.trim()) {
      setError('Username is required');
      return false;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return false;
    }

    return true;
  };

  const handleNext = () => {
    if (activeTab === 'company') {
      if (validateCompanyTab()) {
        setActiveTab('user');
        setError('');
      }
    }
  };

  const handleBack = () => {
    setActiveTab('company');
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateUserTab()) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Pass all company data to the register function
      const result = await register(
        formData.username,
        formData.password,
        formData.email,
        {
          companyName: formData.companyName,
          companyAddress: formData.companyAddress,
          companyCity: formData.companyCity,
          companyState: formData.companyState,
          companyCountry: formData.companyCountry,
          companyPhone: formData.companyPhone,
          companyEmail: formData.companyEmail,
          companyGST: formData.companyGST
        }
      );

      // Check if result exists and has success property
      if (result && result.success) {
        navigate('/login', {
          state: { message: 'Registration successful! Please sign in.' }
        });
      } else {
        setError(result?.error || 'Registration failed. Please try again.');
      }
    } catch (error) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Registration error:', error);
    } finally {
      setLoading(false);
    }
  };

  // Company Tab Content
  const renderCompanyTab = () => (
    <div className="tab-content register-modern-tab">
      <div className="text-center mb-3">
        <div className="auth-icon text-primary register-modern-icon">
          <i className="bi bi-building fs-1"></i>
        </div>
        <h4 className="auth-title register-modern-section-title">Company Information</h4>
        <p className="auth-subtitle text-muted register-modern-section-subtitle">Tell us about your company</p>
      </div>

      <div className="form-group mb-3">
        <label className="form-label fw-semibold register-modern-label">Company Name *</label>
        <div className="input-group register-modern-input-wrap">
          <span className="input-group-text register-modern-input-icon">
            <i className="bi bi-building"></i>
          </span>
          <input
            type="text"
            name="companyName"
            className="form-control register-modern-input"
            placeholder="Enter your company name"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="form-group mb-3">
        <label className="form-label fw-semibold register-modern-label">Address</label>
        <div className="input-group register-modern-input-wrap">
          <span className="input-group-text register-modern-input-icon">
            <i className="bi bi-geo-alt"></i>
          </span>
          <textarea
            name="companyAddress"
            className="form-control register-modern-input"
            placeholder="Company address"
            rows="2"
            value={formData.companyAddress}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label fw-semibold register-modern-label">City</label>
            <div className="input-group register-modern-input-wrap">
              <span className="input-group-text register-modern-input-icon">
                <i className="bi bi-building"></i>
              </span>
              <input
                type="text"
                name="companyCity"
                className="form-control register-modern-input"
                placeholder="City"
                value={formData.companyCity}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label fw-semibold register-modern-label">State</label>
            <div className="input-group register-modern-input-wrap">
              <span className="input-group-text register-modern-input-icon">
                <i className="bi bi-geo"></i>
              </span>
              <input
                type="text"
                name="companyState"
                className="form-control register-modern-input"
                placeholder="State"
                value={formData.companyState}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label fw-semibold register-modern-label">Country</label>
            <div className="input-group register-modern-input-wrap">
              <span className="input-group-text register-modern-input-icon">
                <i className="bi bi-globe"></i>
              </span>
              <input
                type="text"
                name="companyCountry"
                className="form-control register-modern-input"
                placeholder="Country"
                value={formData.companyCountry}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label fw-semibold register-modern-label">Phone</label>
            <div className="input-group register-modern-input-wrap">
              <span className="input-group-text register-modern-input-icon">
                <i className="bi bi-telephone"></i>
              </span>
              <input
                type="tel"
                name="companyPhone"
                className="form-control register-modern-input"
                placeholder="Phone number"
                value={formData.companyPhone}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label fw-semibold register-modern-label">Company Email</label>
            <div className="input-group register-modern-input-wrap">
              <span className="input-group-text register-modern-input-icon">
                <i className="bi bi-envelope"></i>
              </span>
              <input
                type="email"
                name="companyEmail"
                className="form-control register-modern-input"
                placeholder="Company email"
                value={formData.companyEmail}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label fw-semibold register-modern-label">GST Number</label>
            <div className="input-group register-modern-input-wrap">
              <span className="input-group-text register-modern-input-icon">
                <i className="bi bi-file-text"></i>
              </span>
              <input
                type="text"
                name="companyGST"
                className="form-control register-modern-input"
                placeholder="GST number (optional)"
                value={formData.companyGST}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="d-grid gap-2 mt-3">
        <button
          type="button"
          className="btn btn-primary btn-lg register-modern-primary-btn"
          onClick={handleNext}
        >
          Continue to User Information
          <i className="bi bi-arrow-right ms-2"></i>
        </button>
      </div>
    </div>
  );

  // User Tab Content
  const renderUserTab = () => (
    <div className="tab-content register-modern-tab">
      <div className="text-center mb-3">
        <div className="auth-icon text-success register-modern-icon register-modern-icon--user">
          <i className="bi bi-person fs-1"></i>
        </div>
        <h4 className="auth-title register-modern-section-title">User Information</h4>
        <p className="auth-subtitle text-muted register-modern-section-subtitle">Create your administrator account</p>
      </div>

      <div className="form-group mb-3">
        <label className="form-label fw-semibold register-modern-label">Username *</label>
        <div className="input-group register-modern-input-wrap">
          <span className="input-group-text register-modern-input-icon">
            <i className="bi bi-person"></i>
          </span>
          <input
            type="text"
            name="username"
            className="form-control register-modern-input"
            placeholder="Choose a username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="form-group mb-3">
        <label className="form-label fw-semibold register-modern-label">Email (Optional)</label>
        <div className="input-group register-modern-input-wrap">
          <span className="input-group-text register-modern-input-icon">
            <i className="bi bi-envelope"></i>
          </span>
          <input
            type="email"
            name="email"
            className="form-control register-modern-input"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="form-group mb-3">
        <label className="form-label fw-semibold register-modern-label">Password *</label>
        <div className="input-group register-modern-input-wrap">
          <span className="input-group-text register-modern-input-icon">
            <i className="bi bi-lock"></i>
          </span>
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            className="form-control register-modern-input"
            placeholder="Create a password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button
            type="button"
            className="btn btn-outline-secondary register-modern-toggle"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
          </button>
        </div>
        <div className="form-text">Must be at least 6 characters long</div>
      </div>

      <div className="form-group mb-3">
        <label className="form-label fw-semibold register-modern-label">Confirm Password *</label>
        <div className="input-group register-modern-input-wrap">
          <span className="input-group-text register-modern-input-icon">
            <i className="bi bi-lock-fill"></i>
          </span>
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            name="confirmPassword"
            className="form-control register-modern-input"
            placeholder="Confirm your password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
          <button
            type="button"
            className="btn btn-outline-secondary register-modern-toggle"
            onClick={() => setShowConfirmPassword((prev) => !prev)}
            aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
          >
            <i className={`bi ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
          </button>
        </div>
      </div>

      <div className="d-grid gap-2 mt-3">
        <button
          type="button"
          className="btn btn-outline-secondary btn-lg mb-2 register-modern-back-btn"
          onClick={handleBack}
        >
          <i className="bi bi-arrow-left me-2"></i>
          Back to Company Info
        </button>

        <button
          type="submit"
          className="btn btn-success btn-lg auth-btn register-modern-submit-btn"
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
              Creating Account...
            </>
          ) : (
            <>
              <i className="bi bi-person-plus me-2"></i>
              Create Account
            </>
          )}
        </button>
      </div>
    </div>
  );

  return (
    <div className="auth-container register-modern-shell">
      <div className="register-modern-backdrop-shape register-modern-backdrop-shape--one"></div>
      <div className="register-modern-backdrop-shape register-modern-backdrop-shape--two"></div>

      <div className="auth-wrapper register-modern-wrapper">
        <div className="auth-card compact-card register-modern-card">
          {/* Header Section */}
          <div className="auth-header text-center mb-3 register-modern-header">
            <div className="register-modern-badge">
              <img src="/logo192.png" alt="VH logo" className="register-modern-badge__logo" />
              <span className="register-modern-badge__text">VrisHr</span>
            </div>
            <h2 className="auth-title">Create Account</h2>
            <p className="auth-subtitle mb-0">Join our HRMS platform</p>
          </div>

          {/* Progress Steps */}
          <div className="progress-steps mb-3 register-modern-progress">
            <div className="steps-container">
              <div className={`step ${activeTab === 'company' ? 'active' : 'completed'}`}>
                <div className="step-icon">
                  <i className="bi bi-building"></i>
                </div>
                <span className="step-label">Company</span>
              </div>
              <div className="step-connector"></div>
              <div className={`step ${activeTab === 'user' ? 'active' : ''}`}>
                <div className="step-icon">
                  <i className="bi bi-person"></i>
                </div>
                <span className="step-label">User</span>
              </div>
            </div>
          </div>

          {/* Error Alert */}
          {error && (
            <div className="alert alert-danger d-flex align-items-center mb-3 register-modern-alert" role="alert">
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              <div>{error}</div>
            </div>
          )}

          {/* Registration Form */}
          <form onSubmit={handleSubmit}>
            {activeTab === 'company' ? renderCompanyTab() : renderUserTab()}
          </form>

          {/* Footer Links */}
          <div className="auth-footer text-center mt-3">
            <p className="mb-0">
              Already have an account?{' '}
              <Link to="/login" className="auth-link">
                Sign in here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
